<template>
    <nav class="bg-white rounded shadow">
        <template v-for="(item, i) in menu" v-if="routeSecurity(i)">
            <router-link :to="i"
                         class="d-flex flex-column justify-content-center align-items-center py-1 my-1 py-lg-2 my-lg-2">
              <span :class="item.icon" class="icon-s text-primary"></span>
                <span class="text-4 d-none d-lg-inline-block text-capitalize">{{$tc('sidenav.'+item.display, 2)}}</span>
            </router-link>
        </template>
    </nav>
</template>

<script>

  import router from '../router'

  export default {
    name: 'sidenav',
    created () {

      let routes = router.options.routes
      for (let i in routes) {
        let excludes = ['view', 'mySettings']
        let path = routes[i].path
        let name = routes[i].name
        let secure = routes[i].meta ? routes[i].meta.secure : '';
        if (!excludes.includes(name)) {
          this.menu[path] = {
            'display': name,
            'icon': name === 'personalDashboard' ? 'icon-orders' : 'icon-' + name,
            'secure': secure ? secure : false,
          }
        }
      }

    },
    data () {
      return {
        menu: {}
      }
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      }
    },
    methods: {
      routeSecurity (i) {
        if (this.menu[i].secure) {
          return this.isAdmin
        } else {
          return true
        }
      }
    }
    // filters: {
    //   splitAfterCapital: function (value) {
    //     if (!value) return ''
    //     if (value.match(/[A-Z][a-z]+/g)) {
    //       return value.split(/(?=[A-Z])/).join(' ')
    //     }
    //     return value
    //   }
    // }
  }

</script>

